/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./template-previewer-dialog.vue?vue&type=template&id=09796fd0&"
import script from "./template-previewer-dialog.vue?vue&type=script&lang=js&"
export * from "./template-previewer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./template-previewer-dialog.vue?vue&type=style&index=0&id=09796fd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports